import React from "react";
import "./receiptB2C.css";
import { useSelector } from "react-redux";
import { fetchZoneLogoById } from "services/zone";
import zoneLocalStorageId from "utils/zone";
import { useQuery } from "@tanstack/react-query";

const Receipt = () => {
  const [receiptData] = React.useState(() => {
    return JSON.parse(localStorage.getItem("receiptData"));
  });

  const { user } = useSelector((state) => state.jwtAuthreducer);

  const allItems = [
    ...(receiptData?.investigtion_details || []),
    ...(receiptData?.package_details?.map((pkg) => ({
      investigation_name: pkg.package_name,
      investigation_id: pkg.package_id,
      mrp: pkg.mrp,
      rate: pkg.rate,
    })) || []),
  ];

  const totalMRP = allItems.reduce(
    (sum, item) => sum + (Number(item.mrp) || 0),
    0
  );
  const totalRate = allItems.reduce(
    (sum, item) => sum + (Number(item.rate) || 0),
    0
  );
  const totalDiscount = totalMRP - totalRate;

  const { data: zoneData, isLoading: isZoneLoading } = useQuery(
    ["fetch-zone-logo-by-id", zoneLocalStorageId()],
    () => fetchZoneLogoById(zoneLocalStorageId()),
    {
      enabled: !!zoneLocalStorageId(),
      select: (res) => res || [],
      onSuccess: (res) => {
        console.log("Zone data fetched:", res);
      },
      onError: (err) => {
        console.error("Error fetching zone data:", err);
      },
    }
  );

  if (!receiptData) {
    return <div>No receipt data available</div>;
  }

  const printReceipt = () => {
    window.print();
  };

  return (
    <div className="recepit-container">
      <div className="receipt-wrapper">
        <div className="receipt-inner">
          <div className="mb-2 position-relative">
            <div className="d-flex align-items-center">
              <div className="logo">
                {!isZoneLoading && (
                  <img
                    src={
                      zoneData?.data
                        ? `data:image/png;base64,${zoneData.data}`
                        : "../assets/img/medicity_logo.png"
                    }
                    alt={zoneData?.data ? "Zone Logo" : "Medicity"}
                    width={140}
                    height={90}
                    style={{ maxWidth: "100%", height: "auto" }}
                    onError={(e) => {
                      e.target.src = "../assets/img/medicity_logo.png";
                    }}
                  />
                )}
              </div>
            </div>
            <div className="receipt-header-unique position-absolute top-50 start-50 translate-middle">
              Estimate Receipt
            </div>
          </div>
          <div className="ms-3 mt-3">
            <div className="row">
              <div className="receipt-row receipt16 receipt-status">
                Panel:&nbsp;
                <span>{receiptData?.company_name?.value || ""}</span>
              </div>
            </div>
            {receiptData?.membership_card_no && (
              <div className="row">
                <div className="receipt-row receipt16 receipt-status">
                  Membership Card No:&nbsp;
                  <span> {receiptData.membership_card_no}</span>
                </div>
              </div>
            )}
            <div className="row">
              <div className="receipt-row receipt16 receipt-status">
                Address:&nbsp; <span> {receiptData?.address || ""}</span>
              </div>
            </div>
          </div>
          <div className="receipt-row receipt-bttm-border">
            <div className="receipt-row-1 receipt-colheaders receipt24">
              Service Name
            </div>
            <div
              className="receipt-row-2 receipt-colheaders receipt24"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "40%",
              }}
            >
              <div style={{ width: "33.33%", textAlign: "right" }}>MRP</div>
              <div style={{ width: "33.33%", textAlign: "right" }}>
                Discount
              </div>
              <div style={{ width: "33.33%", textAlign: "right" }}>Rate</div>
            </div>
          </div>

          {allItems?.map((item, index) => {
            const mrp = Number(item?.mrp) || 0;
            const rate = Number(item?.rate) || 0;
            const discount = mrp - rate;

            return (
              <div className="receipt-row receipt-bttm-border" key={index}>
                <div className="receipt-row-1">
                  {item?.investigation_name || "N/A"}
                </div>
                <div
                  className="receipt-row-2"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "40%",
                  }}
                >
                  <div
                    style={{
                      width: "33.33%",
                      textAlign: "right",
                      wordBreak: "break-all",
                    }}
                  >
                    {mrp.toFixed(2)}
                  </div>
                  <div
                    style={{
                      width: "33.33%",
                      textAlign: "right",
                      wordBreak: "break-all",
                    }}
                  >
                    {discount.toFixed(2)}
                  </div>
                  <div
                    style={{
                      width: "33.33%",
                      textAlign: "right",
                      wordBreak: "break-all",
                    }}
                  >
                    {rate.toFixed(2)}
                  </div>
                </div>
              </div>
            );
          })}

          {/* Total Footer Row */}
          <div className="receipt-row receipt-bttm-border">
            <div className="receipt-row-1 receipt-total-lbl receipt-colheaders receipt24">
              Total
            </div>
            <div
              className="receipt-row-2 receipt-colheaders receipt24"
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "40%",
              }}
            >
              <div
                style={{
                  width: "33.33%",
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                {totalMRP.toFixed(2)}
              </div>
              <div
                style={{
                  width: "33.33%",
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                {totalDiscount.toFixed(2)}
              </div>
              <div
                style={{
                  width: "33.33%",
                  textAlign: "right",
                  fontWeight: "bold",
                }}
              >
                {totalRate.toFixed(2)}
              </div>
            </div>
          </div>

          <div className="receipt-bttm-border">
            <div className="receipt-row receipt-totals">
              <div className="receipt-row-1 receipt-total-lbl">Payable Amt</div>
              <div className="receipt-row-2 receipt-black receipt16">
                {totalRate.toFixed(2)}
              </div>
            </div>
          </div>
          <div className="signature-section">
            <div className="signature-left">
              <div>
                <p>(Full Payment Before Investigation)</p>
                Printed By: <span>{user?.employee_name || ""}</span>
              </div>
            </div>
            <div className="signature-right">
              <div className="signature-box">
                <hr className="signature-line" />
                <p>Signature</p>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center mt-3">
            <button className="btn btn-primary" onClick={printReceipt}>
              Download Receipt
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Receipt;
